export default __webpack_public_path__ + "static/media/prosper-telehealth.0aecd8ec.svg";